exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btn-shopping-cart{\n  border-radius: 20px;\n  border: 1px solid #e0112b;\n  background: #fff;\n  display: inline-block;\n  width: 122px;\n  height: 36px;\n  line-height: 36px;\n  color: #e0112b;\n  font-weight: 500;\n  font-size: 16px;\n  text-align: left;\n  position: relative;\n  padding-left: 24px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n#btn-shopping-cart .cart-items{\n  width: 40px;\n  height: 40px;\n  background: #525865;\n  color: #fff;\n  border-radius: 50%;\n  display: inline-block;\n  position: absolute;\n  right: -2px;\n  top: -3px;\n  text-align: center;\n  line-height: 40px;\n}\n\n#btn-shopping-cart.with-items .cart-items{\n  background: #e0112b;\n}\n\n#btn-shopping-cart.cart-open{\n  text-decoration: underline;\n}\n\n.logo-section .shoppingcart-container .shoppingcart-footer .btn-primary{\n  width: 163px;\n}\n\n.open-car, #btn-shopping-cart {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/structure/navbar/navbar.component.css
// module id = ../../../../../src/app/components/structure/navbar/navbar.component.css
// module chunks = main